import { z } from 'zod';
import { cuid, paginacao } from './primitives.js';
import { dadosParceiroAtualizarShape, dadosParceiroShape, documentoParceiroSchema, naturezaParceiroSchema, umPrincipal, type DadosParceiroResponse } from './parceiros.js';

const ufDestino = z.string().regex(/^[A-Z]{2}$/, 'UF com 2 letras maiusculas');

/**
 * Cliente = papel CLIENTE de um Parceiro de Negocio (Sessao 30). `parceiroId` usa o parceiro que ja existe ("este CNPJ ja esta cadastrado");
 * sem ele, o parceiro nasce junto. `uf` e `municipio` continuam aceitos como atalho do endereco principal (a UF do endereco principal e a UF
 * de destino padrao do orcamento, QT20).
 */
export const criarClienteSchema = z
  .object({
    nome: z.string().trim().min(1).max(200).optional(),
    documento: documentoParceiroSchema.optional(),
    natureza: naturezaParceiroSchema.optional(),
    /** Parceiro ja existente que ganha o papel de cliente. */
    parceiroId: cuid.optional(),
    uf: ufDestino.optional(),
    municipio: z.string().trim().min(1).max(100).optional(),
    ...dadosParceiroShape,
  })
  .superRefine((v, ctx) => {
    if (!v.nome && !v.parceiroId) ctx.addIssue({ code: 'custom', path: ['nome'], message: 'Informe o nome do cliente' });
    umPrincipal(v.enderecos ?? [], ctx);
  });
export type CriarClienteDto = z.infer<typeof criarClienteSchema>;

export const atualizarClienteSchema = z
  .object({
    nome: z.string().trim().min(1).max(200),
    documento: documentoParceiroSchema.nullable(),
    natureza: naturezaParceiroSchema,
    uf: ufDestino.nullable(),
    municipio: z.string().trim().min(1).max(100).nullable(),
    ...dadosParceiroAtualizarShape,
  })
  .partial()
  .superRefine((v, ctx) => umPrincipal(v.enderecos ?? [], ctx))
  .refine((v) => Object.keys(v).length > 0, 'Informe ao menos um campo');
export type AtualizarClienteDto = z.infer<typeof atualizarClienteSchema>;

export const listarClientesSchema = paginacao.extend({
  q: z.string().trim().min(1).max(100).optional(),
});
export type ListarClientesQuery = z.infer<typeof listarClientesSchema>;

export interface ClienteResponse extends DadosParceiroResponse {
  /** Vem do Protheus (rotina em IMPORTAR): os campos de `CAMPOS_DO_PROTHEUS` sao somente leitura; a API recusa a edicao (409 CAMPO_DO_PROTHEUS). */
  doProtheus?: boolean;
  id: string;
  nome: string;
  documento: string | null;
  /** UF e municipio do endereco principal (espelho). */
  uf: string | null;
  municipio: string | null;
  createdAt: string;
  updatedAt: string;
}
